var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { testIsMobile } from "@@/Util";
import { action, makeObservable, observable } from "mobx";
export class RowCol {
    constructor() {
        this.id = "";
        this.sitem = "";
        this.position = "left";
        this.showname = false;
        this.text = "";
        this.hasimage = false;
        this.leftoffset = "0";
        this.rightoffset = "0";
        makeObservable(this);
    }
    hasImage(img) {
        this.hasimage = img;
    }
    setLeftoffset(oose) {
        this.leftoffset = oose;
    }
    setRighttoffset(oose) {
        this.rightoffset = oose;
    }
    setPosition(pos) {
        if (pos === "left") {
            this.position = pos;
        }
        else if (pos === "right") {
            this.position = pos;
        }
        else if (pos === "center") {
            this.position = pos;
        }
    }
    setText(text) {
        this.text = text;
    }
    setShowName(show) {
        this.showname = show;
    }
    setSchemaItem(id) {
        this.sitem = id;
    }
}
__decorate([
    observable,
    __metadata("design:type", String)
], RowCol.prototype, "sitem", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], RowCol.prototype, "position", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RowCol.prototype, "showname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RowCol.prototype, "text", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RowCol.prototype, "hasimage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RowCol.prototype, "leftoffset", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RowCol.prototype, "rightoffset", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RowCol.prototype, "hasImage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RowCol.prototype, "setLeftoffset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RowCol.prototype, "setRighttoffset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RowCol.prototype, "setPosition", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RowCol.prototype, "setText", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RowCol.prototype, "setShowName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RowCol.prototype, "setSchemaItem", null);
export class WorksheetPrintRow {
    constructor(id) {
        this.id = id;
        this.totalcolss = 0;
        this.rowcols = [];
        this.showastable = false;
        this.height = "";
        makeObservable(this);
    }
    setHeight(height) {
        this.height = height;
    }
    setShowAsTable(show) {
        this.showastable = show;
    }
    setCols(col) {
        if (col > this.rowcols.length) {
            for (let i = this.rowcols.length; i < col; i++) {
                const col = new RowCol();
                col.id = ++this.totalcolss + "_" + this.id;
                this.rowcols.push(col);
            }
        }
        else if (col < this.rowcols.length) {
            // lets slice this!
            this.rowcols.splice(col, this.rowcols.length);
        }
    }
    addCol() {
        const col = new RowCol();
        col.id = ++this.totalcolss + "_" + this.id;
        this.rowcols.push(col);
        return col;
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], WorksheetPrintRow.prototype, "rowcols", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintRow.prototype, "showastable", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintRow.prototype, "height", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], WorksheetPrintRow.prototype, "setHeight", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], WorksheetPrintRow.prototype, "setShowAsTable", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], WorksheetPrintRow.prototype, "setCols", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], WorksheetPrintRow.prototype, "addCol", null);
export class WorksheetPrintTemplateStore {
    constructor() {
        this.top = 20;
        this.left = testIsMobile() ? 10 : 200;
        this.myzindex = -1;
        this.width = testIsMobile() ? window.innerWidth - 100 : 1000;
        this.height = testIsMobile() ? window.innerHeight - 100 : window.innerHeight - 100;
        this.show = false;
        this.dragging = false;
        this.showeditview = false;
        this.comp = new Map();
        this.selectedrowid = "";
        this.paperwidth = 0;
        this.paperheight = 0;
        this.orientation = "port";
        this.papertype = "";
        this.selectedcol = "";
        this.papermeasure = "mm";
        this.activedisplaymode = "body";
        this.headerheight = 100;
        this.footerheight = 100;
        this.editid = "";
        this.printmodeonly = false;
        this.newtemplatemode = false;
        this.headerrow = new WorksheetPrintRow("__header");
        this.footerrow = new WorksheetPrintRow("__footer");
        this.schemaid = "";
        this.letrid = "";
        this.selrow = undefined;
        this.selcol = undefined;
        this.rowsindex = 0;
        this.rows = [];
        this.iseditmode = false;
        this.loading = false;
        this.saving = false;
        this.name = "";
        this.deleteids = new Set();
        makeObservable(this);
        APPEvent.addSubscriberForGetPrintTemplate((forms) => {
            for (const fr of forms) {
                this.addTemplate(fr);
            }
            this.setLoading(false);
        });
        APPEvent.addSubscriberForAddPrintTemplate((form) => {
            if (this.saving) {
                if (form.ok) {
                    this.addTemplate(form.res);
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to save the template. Please try again later or contact support.");
                }
                this.setSaving(false);
                this.setNewTemplateMode(false);
            }
        });
        APPEvent.addSubscriberForDeletePrintTemplat((del) => {
            if (del.ok) {
                this.removeTemplate(del.id);
            }
            else {
                APPEvent.publishApperror("Sorry, failed to delete the template. Please try again later or contact support.");
            }
            this.removeDeleteField(del.id);
            this.setSaving(false);
            this.setEditModeId("");
        });
        APPEvent.addSubscriberForUpdatePrintTemplate((form) => {
            if (this.saving) {
                if (!form.ok) {
                    APPEvent.publishApperror("Sorry, failed to update the template. Please try again later or contact support.");
                }
                else {
                    this.addTemplate(form.res);
                }
                this.setSaving(false);
                this.setEditModeId("");
                this.iseditmode = false;
            }
        });
    }
    setActiveDisplayMode(mode) {
        this.activedisplaymode = mode;
    }
    setOrientation(or) {
        if (this.orientation === or)
            return;
        this.orientation = or;
        if (or === 'port') {
            if (this.paperheight < this.paperwidth) {
                const cw = this.paperheight;
                this.setPaperHeight(this.paperwidth);
                this.setPaperWidth(cw);
            }
        }
        else {
            if (this.paperheight > this.paperwidth) {
                const cw = this.paperheight;
                this.setPaperHeight(this.paperwidth);
                this.setPaperWidth(cw);
            }
        }
    }
    setPrintModeOnly(printmode) {
        this.printmodeonly = printmode;
        if (printmode) {
            this.selectedcol = "";
            this.selcol = undefined;
            this.selectedrowid = "";
            this.selrow = undefined;
            this.setEditModeId("");
        }
    }
    setName(name) {
        this.name = name;
    }
    setPaperMeasure(mea) {
        this.papermeasure = mea;
    }
    setShow(show) {
        this.show = show;
    }
    setNewTemplateMode(mode) {
        this.newtemplatemode = mode;
        this.resetRows();
    }
    resetRows() {
        this.rows.splice(0, this.rows.length);
    }
    deleteTemplate() {
        if (!this.editid)
            return;
        this.setSaving(true);
        const req = {
            id: this.editid,
            schemaid: this.schemaid,
            letrid: this.letrid
        };
        Apphandler.sendMessage("deleteprinttemplate", req);
    }
    setEditModeId(id) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        this.editid = id;
        if (id) {
            this.iseditmode = true;
        }
        else {
            this.iseditmode = false;
        }
        this.resetForm();
        if (!id)
            return;
        // lets also set everything here as well !!
        const templ = this.comp.get(id);
        if (templ) {
            this.rowsindex = 0;
            this.setName(templ.name);
            this.setPaperHeight(templ.pageheight);
            this.setPaperMeasure(templ.pageunits);
            this.setPaperWidth(templ.pagewidth);
            this.setOrientation(templ.paperorientation);
            this.setPapertype(templ.papersize);
            this.headerrow = new WorksheetPrintRow("__header");
            this.footerrow = new WorksheetPrintRow("__footer");
            this.setHeaderHeight(templ.headerheight);
            this.setFooterHeight(templ.footerheight);
            // lets make rows now too!!
            for (const rr of templ.component) {
                if (rr.id === "__header") {
                    const row = new WorksheetPrintRow(rr.id);
                    row.setShowAsTable(rr.renderastable);
                    for (const col of rr.col) {
                        const rcol = row.addCol();
                        rcol.setSchemaItem(col.itemid);
                        rcol.setPosition(col.position);
                        rcol.setShowName(col.displayname);
                        rcol.setText((_a = col.itemcontent) !== null && _a !== void 0 ? _a : '');
                        rcol.hasImage((_b = col.isimage) !== null && _b !== void 0 ? _b : false);
                        rcol.setLeftoffset((_c = col.leftoffset) !== null && _c !== void 0 ? _c : 0);
                        rcol.setRighttoffset((_d = col.rightoffset) !== null && _d !== void 0 ? _d : 0);
                    }
                    this.headerrow = row;
                    continue;
                }
                if (rr.id === "__footer") {
                    const row = new WorksheetPrintRow(rr.id);
                    row.setShowAsTable(rr.renderastable);
                    for (const col of rr.col) {
                        const rcol = row.addCol();
                        rcol.setSchemaItem(col.itemid);
                        rcol.setPosition(col.position);
                        rcol.setShowName(col.displayname);
                        rcol.setText((_e = col.itemcontent) !== null && _e !== void 0 ? _e : '');
                        rcol.hasImage((_f = col.isimage) !== null && _f !== void 0 ? _f : false);
                        rcol.setLeftoffset((_g = col.leftoffset) !== null && _g !== void 0 ? _g : 0);
                        rcol.setRighttoffset((_h = col.rightoffset) !== null && _h !== void 0 ? _h : 0);
                    }
                    this.footerrow = row;
                    continue;
                }
                const rid = parseInt(rr.id);
                if (this.rowsindex < rid) {
                    this.rowsindex = rid;
                }
                const row = new WorksheetPrintRow(rr.id);
                row.setShowAsTable(rr.renderastable);
                for (const col of rr.col) {
                    const rcol = row.addCol();
                    rcol.setSchemaItem(col.itemid);
                    rcol.setPosition(col.position);
                    rcol.setShowName(col.displayname);
                    rcol.setText((_j = col.itemcontent) !== null && _j !== void 0 ? _j : '');
                    rcol.hasImage((_k = col.isimage) !== null && _k !== void 0 ? _k : false);
                    rcol.setLeftoffset((_l = col.leftoffset) !== null && _l !== void 0 ? _l : 0);
                    rcol.setRighttoffset((_m = col.rightoffset) !== null && _m !== void 0 ? _m : 0);
                }
                this.rows.push(row);
            }
        }
    }
    setMyZindex(index) {
        this.myzindex = index;
    }
    setHeaderHeight(index) {
        if (isNaN(index)) {
            index = 0;
        }
        if (index > this.paperheight) {
            APPEvent.publishApperror("You have added header height more than page height. This can effect pdf rendering.");
        }
        this.headerheight = index;
    }
    setFooterHeight(index) {
        if (isNaN(index)) {
            index = 0;
        }
        if (index > this.paperheight) {
            APPEvent.publishApperror("You have added footer height more than page height. This can effect pdf rendering.");
        }
        this.footerheight = index;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setSaving(loading) {
        this.saving = loading;
    }
    setTop(top) {
        this.top = top;
    }
    saveNewTemplate() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!this.name.trim()) {
            APPEvent.publishApperror("Please enter name for the template");
            return;
        }
        this.setSaving(true);
        const comp = [];
        for (const rt of this.rows) {
            const cols = [];
            for (const col of (_a = rt.rowcols) !== null && _a !== void 0 ? _a : []) {
                const pc = {
                    displayname: col.showname,
                    position: col.position,
                    itemid: col.sitem,
                    itemcontent: col.sitem === '' ? col.text : '',
                    isimage: col.sitem === '' ? col.hasimage : false,
                    leftoffset: (_b = col.leftoffset) !== null && _b !== void 0 ? _b : 0,
                    rightoffset: (_c = col.rightoffset) !== null && _c !== void 0 ? _c : 0
                };
                cols.push(pc);
            }
            const rc = {
                renderastable: rt.showastable,
                col: cols,
                id: rt.id
            };
            comp.push(rc);
        }
        // lets also add header and footer to this!
        if (this.headerrow) {
            const cols = [];
            for (const col of (_d = this.headerrow.rowcols) !== null && _d !== void 0 ? _d : []) {
                const pc = {
                    displayname: col.showname,
                    position: col.position,
                    itemid: col.sitem,
                    itemcontent: col.sitem === '' ? col.text : '',
                    isimage: col.sitem === '' ? col.hasimage : false,
                    leftoffset: (_e = col.leftoffset) !== null && _e !== void 0 ? _e : 0,
                    rightoffset: (_f = col.rightoffset) !== null && _f !== void 0 ? _f : 0
                };
                cols.push(pc);
            }
            const rc = {
                renderastable: this.headerrow.showastable,
                col: cols,
                id: "__header"
            };
            comp.push(rc);
        }
        if (this.footerrow) {
            const cols = [];
            for (const col of (_g = this.footerrow.rowcols) !== null && _g !== void 0 ? _g : []) {
                const pc = {
                    displayname: col.showname,
                    position: col.position,
                    itemid: col.sitem,
                    itemcontent: col.sitem === '' ? col.text : '',
                    isimage: col.sitem === '' ? col.hasimage : false,
                    leftoffset: (_h = col.leftoffset) !== null && _h !== void 0 ? _h : 0,
                    rightoffset: (_j = col.rightoffset) !== null && _j !== void 0 ? _j : 0
                };
                cols.push(pc);
            }
            const rc = {
                renderastable: this.footerrow.showastable,
                col: cols,
                id: "__footer"
            };
            comp.push(rc);
        }
        const templ = {
            id: this.iseditmode ? this.editid : '',
            schemaid: this.schemaid,
            letrid: this.letrid,
            pageunits: this.papermeasure,
            pageheight: this.paperheight,
            pagewidth: this.paperwidth,
            name: this.name,
            component: comp,
            papersize: this.papertype,
            headerheight: this.headerheight,
            footerheight: this.footerheight,
            paperorientation: this.orientation
        };
        Apphandler.sendMessage(this.iseditmode ? "updateprinttemplate" :
            "addprinttemplate", templ);
    }
    addRow() {
        const row = new WorksheetPrintRow(++this.rowsindex + "");
        row.setCols(1);
        this.rows.push(row);
    }
    addDeleteField(id) {
        this.deleteids.add(id);
    }
    removeDeleteField(id) {
        this.deleteids.delete(id);
    }
    removeRow(index) {
        this.rows.splice(index, 1);
    }
    setPaperWidth(left) {
        this.paperwidth = left;
    }
    setPaperHeight(left) {
        this.paperheight = left;
    }
    setPapertype(left) {
        this.papertype = left;
    }
    setLeft(left) {
        this.left = left;
    }
    setDragging(drg) {
        this.dragging = drg;
    }
    setShowEditView(show) {
        this.showeditview = show;
    }
    addTemplate(tem) {
        this.comp.set(tem.id, tem);
    }
    removeTemplate(id) {
        this.comp.delete(id);
    }
    resetForm() {
        this.rows.splice(0, this.rows.length);
        this.rowsindex = 0;
        this.selectedrowid = "";
        this.selectedcol = "";
        this.name = "";
        this.paperheight = 0;
        this.papermeasure = "mm";
        this.orientation = "port";
        this.papertype = "port";
        this.paperwidth = 0;
        this.headerrow = new WorksheetPrintRow("__header");
        this.footerrow = new WorksheetPrintRow("__footer");
        this.headerheight = 140;
        this.footerheight = 140;
    }
    reset() {
        this.resetForm();
        this.comp.clear();
        this.deleteids.clear();
        this.setLoading(false);
        this.iseditmode = false;
        this.printmodeonly = false;
    }
    setSelectedRowid(id) {
        this.selectedrowid = id;
    }
    setSelectedColid(id) {
        this.selectedcol = id;
    }
    loadAllTemplates() {
        if (this.loading)
            return;
        if (this.comp.size === 0) {
            this.setLoading(true);
        }
        const req = {
            letrid: this.letrid,
            schemaid: this.schemaid
        };
        Apphandler.sendMessage("getprinttemplate", req);
    }
    translateToViewPort(left, top) {
    }
    translateToPage(left, top) {
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "top", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "left", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "myzindex", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "width", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "height", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "dragging", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "showeditview", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], WorksheetPrintTemplateStore.prototype, "comp", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "selectedrowid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "paperwidth", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "paperheight", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "orientation", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "papertype", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "selectedcol", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "papermeasure", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "activedisplaymode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "headerheight", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "footerheight", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "editid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "printmodeonly", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "newtemplatemode", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], WorksheetPrintTemplateStore.prototype, "rows", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "saving", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WorksheetPrintTemplateStore.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], WorksheetPrintTemplateStore.prototype, "deleteids", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setActiveDisplayMode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setOrientation", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setPrintModeOnly", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setPaperMeasure", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setNewTemplateMode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "resetRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setEditModeId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setMyZindex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setHeaderHeight", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setFooterHeight", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setSaving", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setTop", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "addRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "addDeleteField", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "removeDeleteField", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "removeRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setPaperWidth", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setPaperHeight", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setPapertype", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setLeft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setDragging", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setShowEditView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "addTemplate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "removeTemplate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "resetForm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setSelectedRowid", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], WorksheetPrintTemplateStore.prototype, "setSelectedColid", null);
